import {
    ColorEnum,
    FontColorEnum,
    lightColors,
    standardColors,
} from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.constants';

export class SynopticStandardUtils {
    public static formatColor(fiberIndex: number): ColorEnum {
        //Map the fiber index number into a 1–12 range
        return SynopticStandardUtils.getStandardColor(((fiberIndex - 1) % 12) + 1);
    }
    public static getFontColor(color: ColorEnum): FontColorEnum {
        return lightColors.includes(color) ? FontColorEnum.BLACK : FontColorEnum.WHITE;
    }

    public static getStandardColor(colorCode: number): ColorEnum {
        return standardColors[colorCode] ?? ColorEnum.WHITE;
    }
}
